// src/Step4HealthInfo.jsx
import React from 'react';

const ACTIVITY_OPTIONS = [
  {
    value: '0',
    label: 'کم',
    desc: 'بیشتر روز پشت میز یا فعالیت سبک داری',
    icon: '🪑',
  },
  {
    value: '1',
    label: 'متوسط',
    desc: 'فعالیت روزانه معمولی یا پیاده‌روی داری',
    icon: '🚶',
  },
  {
    value: '2',
    label: 'زیاد',
    desc: 'کار یا سبک زندگی پرتحرک داری',
    icon: '🏃',
  },
];

const ALLERGY_OPTIONS = [
  { value: '0', label: 'هیچ‌کدام', icon: '✅' },
  { value: '1', label: 'گلوتن', icon: '🌾' },
  { value: '2', label: 'لبنیات', icon: '🥛' },
  { value: '3', label: 'آجیل', icon: '🥜' },
  { value: '4', label: 'تخم‌مرغ', icon: '🥚' },
];

const MEDICAL_OPTIONS = [
  { value: '0', label: 'هیچ‌کدام', icon: '✅' },
  { value: '1', label: 'دیابت', icon: '🩸' },
  { value: '2', label: 'فشار خون', icon: '❤️' },
  { value: '3', label: 'بیماری قلبی', icon: '🫀' },
  { value: '4', label: 'مشکلات مفصلی', icon: '🦴' },
];

export default function Step4HealthInfo({ form, setF, colors }) {
  const isWorkoutOnly = Number(form.requestedPlan) === 1;
  const isDietOnly = Number(form.requestedPlan) === 2;

  return (
    <div>
      <SectionIntro
        colors={colors}
        title={
          isWorkoutOnly
            ? 'سبک زندگی و محدودیت‌های بدنی'
            : isDietOnly
            ? 'تغذیه و سلامتی'
            : 'سبک زندگی، تغذیه و سلامتی'
        }
        subtitle={
          isWorkoutOnly
            ? 'برای تنظیم شدت تمرین و جلوگیری از حرکات نامناسب، این اطلاعات مهم است.'
            : isDietOnly
            ? 'برای تنظیم رژیم غذایی دقیق‌تر، آلرژی و شرایط پزشکی را مشخص کن.'
            : 'برای هماهنگی بهتر تمرین و رژیم با شرایط واقعی بدن تو، این بخش را کامل کن.'
        }
      />

      <FieldTitle colors={colors}>سطح فعالیت روزانه</FieldTitle>

      <div className="grid md:grid-cols-3 gap-3 mb-6">
        {ACTIVITY_OPTIONS.map((item) => (
          <InfoChoiceCard
            key={item.value}
            active={String(form.activityLevel) === String(item.value)}
            title={item.label}
            desc={item.desc}
            icon={item.icon}
            onClick={() => setF('activityLevel', item.value)}
            colors={colors}
          />
        ))}
      </div>

      {!isWorkoutOnly && (
        <>
          <FieldTitle colors={colors}>آلرژی غذایی</FieldTitle>

          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-6">
            {ALLERGY_OPTIONS.map((item) => (
              <SmallChoiceCard
                key={item.value}
                active={String(form.allergies) === String(item.value)}
                title={item.label}
                icon={item.icon}
                onClick={() => setF('allergies', item.value)}
                colors={colors}
              />
            ))}
          </div>
        </>
      )}

      {isWorkoutOnly && (
        <div
          className="mb-6 rounded-2xl border px-4 py-3 text-sm leading-7"
          style={{
            borderColor: colors.border,
            backgroundColor: 'rgba(37,99,235,0.08)',
            color: colors.sub,
          }}
        >
          چون فقط برنامه تمرینی انتخاب شده، آلرژی غذایی لازم نیست و به‌صورت پیش‌فرض «هیچ‌کدام» در نظر گرفته می‌شود.
        </div>
      )}

      <FieldTitle colors={colors}>شرایط پزشکی یا محدودیت بدنی</FieldTitle>

      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {MEDICAL_OPTIONS.map((item) => (
          <SmallChoiceCard
            key={item.value}
            active={String(form.medicalConditions) === String(item.value)}
            title={item.label}
            icon={item.icon}
            onClick={() => setF('medicalConditions', item.value)}
            colors={colors}
          />
        ))}
      </div>

      <div
        className="mt-5 rounded-2xl border px-4 py-3 text-sm leading-7"
        style={{
          borderColor: colors.border,
          backgroundColor: 'rgba(124,58,237,0.08)',
          color: colors.sub,
        }}
      >
        اگر بیماری یا محدودیت خاصی داری که در گزینه‌ها نیست، فعلاً نزدیک‌ترین گزینه را انتخاب کن؛ در نسخه‌های بعدی امکان توضیح متنی هم اضافه می‌شود.
      </div>
    </div>
  );
}

function SectionIntro({ title, subtitle, colors }) {
  return (
    <div
      className="mb-5 rounded-2xl border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: 'rgba(255,255,255,0.03)',
      }}
    >
      <h3 className="text-lg md:text-xl font-black mb-2">{title}</h3>
      <p className="text-sm leading-7" style={{ color: colors.sub }}>
        {subtitle}
      </p>
    </div>
  );
}

function FieldTitle({ children, colors }) {
  return (
    <h4 className="text-sm font-black mb-3" style={{ color: colors.text }}>
      {children}
    </h4>
  );
}

function InfoChoiceCard({ active, title, desc, icon, onClick, colors }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-[22px] border p-4 text-right transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 16px 35px rgba(37,99,235,0.16)' : 'none',
      }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <span className="text-2xl shrink-0">{icon}</span>

          <div>
            <div className="font-black text-base mb-2">{title}</div>
            <div className="text-xs leading-6" style={{ color: colors.sub }}>
              {desc}
            </div>
          </div>
        </div>

        <span
          className="w-6 h-6 rounded-full border flex items-center justify-center text-xs shrink-0"
          style={{
            borderColor: active ? '#60a5fa' : colors.border,
            backgroundColor: active ? '#2563eb' : 'transparent',
            color: '#fff',
          }}
        >
          {active ? '✓' : ''}
        </span>
      </div>
    </button>
  );
}

function SmallChoiceCard({ active, title, icon, onClick, colors }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-2xl border px-3 py-4 text-center transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 12px 28px rgba(37,99,235,0.14)' : 'none',
      }}
    >
      <div className="text-2xl mb-2">{icon}</div>

      <div
        className="text-sm font-black"
        style={{
          color: active ? '#bfdbfe' : colors.text,
        }}
      >
        {title}
      </div>

      <div
        className="mt-2 mx-auto w-5 h-5 rounded-full border flex items-center justify-center text-[10px]"
        style={{
          borderColor: active ? '#60a5fa' : colors.border,
          backgroundColor: active ? '#2563eb' : 'transparent',
          color: '#fff',
        }}
      >
        {active ? '✓' : ''}
      </div>
    </button>
  );
}